export default __webpack_public_path__ + "static/layout_cloud_front-c53ef5cc1a03f118fc41a90357718aa3.webp";